var _path, _path2, _path3, _circle, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDamageDetection = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M20.1 24.1H4.8c-.3 0-.7-.2-.8-.5-.2-.3-.2-.6 0-1l4-7.3 3.3-5.6c.2-.3.5-.5.9-.5s.7.2.9.5l7.9 13c.2.3.2.7 0 1-.2.2-.5.4-.9.4M8.9 15.8l-4.1 7.4 15.3-.1-7.9-13z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DDE0E8",
  d: "M11.9 14.6h1v4.7h-1zM23.7 15.9h-5.9c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h4.9V6.1h-6.4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h7.4zM6.5 15.9H2.3V5.1h9.1c.3 0 .5.2.5.5s-.2.5-.5.5H3.3v8.8h3.3c.3 0 .5.2.5.5s-.3.5-.6.5"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#42A5F2",
  d: "M17.3 13.4c-.2 0-.3-.1-.4-.2l-1.5-2.3 2.5-2.5h-3.3l-.3-3.5-2 3.1-2.9-.1.9 1.4c.2.2.1.5-.1.7-.2.1-.5.1-.7-.1l-2-3.1 4.2.2L15 1.9l.5 5.5h4.8L16.7 11l1.1 1.6c.2.2.1.5-.1.7-.2.1-.3.1-.4.1"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12.4,
  cy: 20.7,
  r: 0.5,
  fill: "#DDE0E8"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M5.8 14H4.4V7.6c0-.3.2-.5.5-.5s.5.2.5.5V13h.4c.3 0 .5.2.5.5s-.2.5-.5.5M21.8 14h-1.4V7.6c0-.3.2-.5.5-.5s.5.2.5.5V13h.4c.3 0 .5.2.5.5s-.2.5-.5.5"
})));
export default SvgDamageDetection;